import { HidingError } from "components/errors";
import { CircularProgress } from "components/overlays";
import React, { useEffect, useState } from "react";
import styles from './RangePage.module.css'
import { Alert, List, Paper, Stack, Typography } from "@mui/material";
import RangeItem from "./RangeItem";
import { useDispatch, useSelector } from "react-redux";
import { useAddRangeMutation, useDeleteRangeMutation, useGetRangesQuery, useUpdateRangeMutation } from "services/data/rangeApi";
import { setSelected, resetRange, setPagination } from "store/range/rangeSlice";
import RangeDetails from "./RangeDetails";
import { resetApp } from "store/app/appSlice";

const DEFAULT_ERROR = "Ошибка соединения с сервером";

const RangePage = ({setActiveToolbar}) => {

  useEffect( () => setActiveToolbar('range'), []);

  const dispatch = useDispatch();
  const { selected } = useSelector(state => state.range);
        
  const { data, isError,  isFetching } = useGetRangesQuery();
  const [updateRange, {error: updateRangeError, reset: updateRangeReset}] = useUpdateRangeMutation();
  const [addRange, {error: addRangeError, reset: addRangeReset}] = useAddRangeMutation();
  const [deleteRange, {error: deleteRangeError, reset: deleteRangeReset}] = useDeleteRangeMutation();
  
  
  if(isFetching) return <div>Загрузка...</div>;
  if(isError) return <div>Ошибка!</div>;  

  const hideError = () => {
    if(updateRangeError) updateRangeReset();
    if(addRangeError) addRangeReset();
    if(deleteRangeError) deleteRangeReset();
    return;
  };
  
  const openError = () => { 
    return !!updateRangeError || !!addRangeError || !!deleteRangeError || false;
  };

  const getErrorMessage = () => {
    if(updateRangeError) return updateRangeError?.data?.message ?? DEFAULT_ERROR;
    if(addRangeError) return addRangeError?.data?.message ?? DEFAULT_ERROR;
    if(deleteRangeError) return deleteRangeError?.data?.message ?? DEFAULT_ERROR;
    else return'Ошибка';
  };


  const insertRange = (params) => {
    addRange({...params}).unwrap()
      .then((payload) => {
        dispatch(setSelected(payload.body));
      })
      .catch((error) => console.log(error));
  };

  const editRange = (params) => {
    updateRange({...params}).unwrap()
      .then((payload) => { 
        dispatch(setSelected(payload.body));
      })
      .catch((error) => console.log(error));
  };

  const isItemSelected = (item) => item?.id===selected?.id;
  const onItemSelect = (item) => {
    isItemSelected(item) ? dispatch(resetRange()) : dispatch(setSelected(item)); 
  };
  const onItemDelete = ({id}) => {
    deleteRange({id}).unwrap()
      .then(() => {
        dispatch(resetRange());
      })
      .catch((error) => console.log(error));
  };

  const renderItems = (items) => {
    if(!items) {
      return <div className={styles.emptyItem}>Диапазонов пока нет</div>
    }

    return items.map((item, index) => {
      return  <RangeItem
                  key={item.id}
                  isSelected={isItemSelected(item)}
                  onSelect={onItemSelect}
                  onDelete={onItemDelete}
                  { ...item} 
              />;             
    });
  };

  return (
    <div className="page">
      <HidingError 
        open={ openError() }
        message={ getErrorMessage() }
        onClose={hideError}
      />             
      <div className={styles.overlayWrapper}>
        <Paper elevation={1} sx={{flexShrink: 0, marginBottom: '4px'}}>
            <Stack direction="row" spacing={1} className="toolbar">
                <Alert 
                  severity="info"
                  sx={{width: "100%", justifyContent: "center", alignItems: "center"}}
                >
                  Кабинетом будут обрабатываться кассы только из заданных на этой странице диапазонов заводских номеров
                </Alert>
            </Stack>
        </Paper>
        <div className="page-content">
          <div className="left">
            <div className="pagelist">
              <div className="pagelist-body">
                <List>{renderItems(data.body.items)}</List>
              </div>  
            </div>
          </div>    
          <div className="right">
            <RangeDetails
              id={selected?.id}
              start={selected?.start}
              end={selected?.end}
              name={selected?.name}
              disabled={selected?.disabled}
              editRange={editRange}
              addRange={insertRange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RangePage;